import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class UnidadeService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getUnidades(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/unidades' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}


	getUnidadesAtivas(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/unidadesAtivas')
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}	

	getUnidade(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/unidades/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getUnidadesByCliente(cliente_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/unidades/cliente/'+ cliente_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getUnidadesByUsuario(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/unidades/usuario/'+ usuario_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getUnidadesByUsuarioPorCliente(usuario_id,cliente_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/unidades/usuarioCliente/'+ usuario_id +'/'+ cliente_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}	

	getUnidadesByUsuarioAndCliente(usuario_id, cliente_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/unidades/'+ usuario_id + '/' + cliente_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaUnidade(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/unidades', {
				unidade_nome: data.unidade_nome,
				cliente_id: data.cliente_id,
				unidade_status: data.unidade_status
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	editaUnidade(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/unidades/' + data.unidade_id, {
				unidade_nome: data.unidade_nome,
				cliente_id: data.cliente_id,
				unidade_status: data.unidade_status
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	apagaUnidade(id) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/unidades/' + id, {
				unidade_status: 'D'
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	atualizaStatus(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/unidades/' + data.unidade_id, {
				unidade_status: data.unidade_status
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}
}
